

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '../stylus/main.styl'
import colors from 'vuetify/es5/util/colors'
import '@fortawesome/fontawesome-free/css/all.css'


Vue.use(Vuetify, {
  iconfont: 'md',
  rtl:true,
  theme: {
    accent: colors.shades.black,
  },
})
